import './ProjectQuickFacts.css';

export default function ProjectQuickFacts({ project }) {
  const facts = project.quickFacts || [];
  if (!facts.length) return null;

  return (
    <section className="pd-facts" aria-label="Project quick facts">
      <div className="pd-facts__inner">
        {facts.map((fact) => (
          <div key={fact.label} className="pd-fact">
            <span className="pd-fact__value">{fact.value}</span>
            <span className="pd-fact__label">{fact.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
